import { apiService } from '../api/api-client';
import type {
  HistoryFeedFilters,
  MtmRunBook,
  MtmRunItem,
  MtmRunMarkRow,
  PaginatedResponse,
} from '@/types';

export interface HistoryPageParams extends HistoryFeedFilters {
  limit: number;
  offset: number;
}

/** MTM run log (LR-390) — batches across all counterparties, each drilling into per-instrument rows. */
export const mtmRunsService = {
  /**
   * GET /mtm-runs/: one page of Stock-L/B runs, newest-first, narrowed by the History filters.
   *
   * LR-565: `bucket` is filtered SERVER-side (hence the name — this is NOT every run), so repo
   * runs never take a slot on the page.
   */
  async getStockLbRunsPage(params: HistoryPageParams): Promise<PaginatedResponse<MtmRunItem>> {
    return apiService.getPaginated<MtmRunItem>('/mtm-runs/', { ...params, bucket: 'stock_lb' });
  },

  /** GET /mtm-runs/by-counterparty/: one page of Stock-L/B (counterparty, currency) books. */
  async getStockLbBooksPage(params: HistoryPageParams): Promise<PaginatedResponse<MtmRunBook>> {
    return apiService.getPaginated<MtmRunBook>('/mtm-runs/by-counterparty/', {
      ...params,
      bucket: 'stock_lb',
    });
  },

  /** GET /mtm-runs/{id}/: one run in the list-row shape (a deep link older than the loaded pages). */
  async getRun(runId: number): Promise<MtmRunItem> {
    return apiService.get<MtmRunItem>(`/mtm-runs/${runId}/`);
  },

  /** GET /mtm-runs/{id}/marks/ — per-instrument rows for one run (plain list). */
  async getRunMarks(runId: number): Promise<MtmRunMarkRow[]> {
    return apiService.get<MtmRunMarkRow[]>(`/mtm-runs/${runId}/marks/`);
  },
};
